export const WEBSOCKET = {
  initialLoad: 'initialLoadComplete',
  transport: ['websocket'],
  reconnDelay: 5000,
  reconnAttempt: 3,
  path: '/socket',
  authMechanism: 'admin',
}
